import React from 'react';

export default function RaisedHandIcon({ active = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Fingers */}
      <path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11 5.5V3.5a1.5 1.5 0 0 1 3 0V12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 5.5a1.5 1.5 0 0 1 3 0V12" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      {/* Thumb */}
      <path d="M8 13a4 4 0 0 0-3-.5 1.5 1.5 0 0 0-.5 2.5L8 19a5 5 0 0 0 4 2h1a5 5 0 0 0 5-5V8.5a1.5 1.5 0 0 0-3 0" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
